import { Route, Switch } from 'react-router-dom'

import { OccupationDetail } from './detail'

const Occupations = () => {
  const routes = [
    {
      path: '/profile/:onetSoc',
      exact: true,
      render(props) {
        return <OccupationDetail {...props} />
      }
    }
  ]

  return (
    <div>
      <Switch>
        {routes.map((route, idx) => (
          <Route
            key={idx}
            {...route}
            render={props => {
              return route.render({ ...props })
            }}
          />
        ))}
      </Switch>
    </div>
  )
}

export { Occupations }
